module.exports = __webpack_public_path__ + "img/doggie.7b879960.gif";